"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _types = require("../../types");

var _UTButton = _interopRequireDefault(require("../../../UTButton"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var UTCardFooter = function UTCardFooter(_ref) {
  var footer = _ref.footer,
      customButton = _ref.customButton;
  var Button = customButton || _UTButton["default"];
  return _react["default"].createElement("div", {
    className: _stylesModule["default"].base
  }, footer.map(function (button) {
    return _react["default"].createElement(Button, _extends({
      key: button.name,
      className: "".concat(_stylesModule["default"].button, " ").concat(button.className)
    }, button), button.name);
  }));
};

UTCardFooter.propTypes = {
  footer: _types.cardActionsTypes.footer,
  customButton: _propTypes.element
};
var _default = UTCardFooter;
exports["default"] = _default;